<template>
  <div class="tabber">
    <div class="tabberNav" @click="router(1)">
      <img src="@/assets/nav1.png" class="imgs" v-if="nav != 1" />
      <img src="@/assets/nav1Active.png" class="imgs" v-else />
      <div class="text" :class="nav == 1 ? 'active' : ''">流程</div>
    </div>
    <div class="tabberNav" @click="router(2)">
      <img src="@/assets/nav2.png" class="imgs" v-if="nav != 2" />
      <img src="@/assets/nav2Active.png" class="imgs" v-else />
      <div class="text" :class="nav == 2 ? 'active' : ''">待办</div>
    </div>
    <div class="tabberNav" @click="router(3)">
      <img src="@/assets/nav3.png" class="imgs" v-if="nav != 3" />
      <img src="@/assets/nav3Active.png" class="imgs" v-else />
      <div class="text" :class="nav == 3 ? 'active' : ''">已办</div>
    </div>
    <div class="tabberNav" @click="router(4)">
      <img src="@/assets/nav3.png" class="imgs" v-if="nav != 4" />
      <img src="@/assets/nav3Active.png" class="imgs" v-else />
      <div class="text" :class="nav == 4 ? 'active' : ''">知识库</div>
    </div>
    <div class="tabberNav" @click="router(5)" v-if="config.project == 'zsgly'">
      <img src="@/assets/me.png" class="imgs" v-if="nav != 5" />
      <img src="@/assets/me-selected.png" class="imgs" v-else />
      <div class="text" :class="nav == 5 ? 'active' : ''">我的</div>
    </div>
  </div>
</template>

<script>
import yhconfig from "@/yhconfig.js";
export default {
  props: {
    nav: ""
  },
  data() {
    return {
      config: {}
    };
  },
  created() {
    this.config = yhconfig;
  },
  methods: {
    router(index) {
      if (index != this.nav) {
        if (index == 1) {
          this.$router.push({ path: "/process" });
        } else if (index == 2) {
          sessionStorage.setItem("done", 0);
          this.$router.push({ path: "/" });
        } else if (index == 3) {
          sessionStorage.setItem("done", 1);
          this.$router.push({ path: "/done" });
        } else if (index == 4) {
          this.$router.push({ path: "/knowledge" });
        } else if (index == 5) {
          this.$router.push({ path: "/mine" });
        }
      }
    }
  }
};
</script>

<style lang="less">
.tabber {
  width: 100%;
  height: 110px;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 100;
  background: #fafafa;
  display: flex;
  justify-content: space-around;
  border-top: 1px solid #d9d9d9;

  .tabberNav {
    text-align: center;

    .imgs {
      width: 45px;
      padding-top: 18px;
    }

    .text {
      font-size: 24px;
      line-height: 40px;
      height: 40px;
    }

    .active {
      color: #097efe;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tabbers.vue